import { MainContentArea, ContentHeader, Button, PlusIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { CouponsList } from "../../components/coupons/CouponsList";

// Add Translation
export const Coupons: React.FC = () => {
  const { t } = useTranslation();

  const [openAddNewCouponDrawer, setOpenAddNewCouponDrawer] = useState<boolean>(false);

  const setAddNewCouponDrawerFunction = (status: boolean) => {
    setOpenAddNewCouponDrawer(status)
  }

  const { roles } = useRolesContext();

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("main_menu.coupons")}
          extra={roles.URL_FORWARDS_CREATE && <Button
            key="add-new-coupon"
            type="primary"
            icon={<PlusIcon />}
            onClick={async () => {
              setAddNewCouponDrawerFunction(true);
            }}
          >
            {t("main_menu.coupons")}
          </Button>}
        />
      }
    >
      <CouponsList openAddNewCouponDrawer={openAddNewCouponDrawer} setAddNewCouponDrawerFunction={setAddNewCouponDrawerFunction}></CouponsList>

    </MainContentArea>
  );
};
